import { Trans } from 'react-i18next';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { tokens, Icon, Text, Link } from '@hotjar/hotsauce';
import { useCurrentSite } from '@hotjar/site';
import { getRoute } from '@hotjar/webapp/utils/routing';
import { SETTINGS } from '@hotjar/webapp/constants/routes/site';

export interface IpBlockingInfoProps {
  showIpBlockingInfo: boolean;
}

const FlexContainer = styled.div`
  display: flex;
`;
const Container = styled.div`
  margin: ${tokens.spacer.x3} 0 0 auto;
`;

export function IpBlockingInfo({ showIpBlockingInfo }: IpBlockingInfoProps): JSX.Element | null {
  const { data: currentSite } = useCurrentSite();

  if (!showIpBlockingInfo || !currentSite) {
    return null;
  }

  const settingsPath = getRoute(SETTINGS.path, { siteId: currentSite?.id });
  return (
    <FlexContainer>
      <Container>
        <Icon color="text_light" size="m" icon="info" />
        <Text
          textColor="text_light"
          textType="body2"
          css={css`
            margin-left: ${tokens.spacer.x1};
          `}
        >
          <Trans i18nKey="common:recordings.list.ip-blocking-info">
            <Link href={`${settingsPath}#ip-blocking`} kind="inline">
              IP Blocking
            </Link>
          </Trans>
        </Text>
      </Container>
    </FlexContainer>
  );
}
